import { useContext } from "react"
import { VenueContext } from "./VenueContext"

export const useVenue = () => {
  const values = useContext(VenueContext)
  return values
}
